import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUserProfile } from "../api/USERS/users";
import { toast } from "react-toastify";

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, userData }) => updateUserProfile(userId, userData),
    onSuccess: (data) => {
      // Mettre à jour le cache de l'utilisateur actuel
      queryClient.setQueryData(["currentUser"], data);
      queryClient.invalidateQueries({ queryKey: ["currentUser"] });
      
      toast.success("Profil mis à jour avec succès", {
        autoClose: 3000,
        hideProgressBar: true,
        pauseOnHover: true,
      });
    },
    onError: (error) => {
      toast.error(error.message || "Erreur lors de la mise à jour du profil", {
        autoClose: 3000,
        hideProgressBar: true,
        pauseOnHover: true,
      });
    },
  });
}
